import React from 'react';
import { motion } from 'framer-motion';

/* Animated architectural line drawing (used for projects that don't have photos yet).
   `variant` picks a building silhouette by category. */
const SHAPES = {
  'Site Layout': [
    'M20 150 L20 110 L60 110 L60 150', 'M70 150 L70 100 L110 100 L110 150', 'M120 150 L120 115 L160 115 L160 150',
    'M170 150 L170 105 L210 105 L210 150', 'M10 150 L230 150', 'M30 130 L50 130 M80 120 L100 120 M130 132 L150 132 M180 125 L200 125',
    'M20 110 L40 92 L60 110 M70 100 L90 82 L110 100 M120 115 L140 97 L160 115 M170 105 L190 87 L210 105',
  ],
  'Commercial Building': [
    'M60 150 L60 30 L140 30 L140 150', 'M140 150 L140 60 L190 60 L190 150', 'M40 150 L210 150',
    'M75 45 L125 45 M75 65 L125 65 M75 85 L125 85 M75 105 L125 105 M75 125 L125 125',
    'M150 75 L180 75 M150 95 L180 95 M150 115 L180 115', 'M90 150 L90 135 L110 135 L110 150', 'M100 30 L100 14',
  ],
  'Residential Building': [
    'M40 150 L40 80 L120 80 L120 150', 'M120 150 L120 60 L200 60 L200 150', 'M30 80 L130 80', 'M110 60 L210 60',
    'M55 95 L80 95 L80 120 L55 120 Z', 'M140 75 L180 75 L180 100 L140 100 Z', 'M150 150 L150 120 L170 120 L170 150',
    'M20 150 L220 150', 'M85 150 L85 128 L105 128 L105 150',
  ],
};

export default function Blueprint({ category, className = '' }) {
  const paths = SHAPES[category] || SHAPES['Commercial Building'];
  return (
    <svg className={`blueprint-svg ${className}`} viewBox="0 0 240 170" fill="none" aria-hidden="true">
      {paths.map((d, i) => (
        <motion.path key={i} d={d} stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
          initial={{ pathLength: 0, opacity: 0 }} whileInView={{ pathLength: 1, opacity: 1 }} viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.4, delay: 0.15 + i * 0.12, ease: [0.65, 0, 0.35, 1] }} />
      ))}
    </svg>
  );
}
